var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginPasswordNonVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.52904L2.46 2.67859L15 13.875L14.0475 14.7322L11.7375 12.6697C10.875 12.9241 9.96 13.0581 9 13.0581C5.25 13.0581 2.0475 10.9755 0.75 8.03573C1.2675 6.85716 2.0925 5.81921 3.1425 4.99555L1.5 3.52904ZM9 6.0268C9.59674 6.0268 10.169 6.23846 10.591 6.6152C11.0129 6.99195 11.25 7.50293 11.25 8.03573C11.2504 8.26379 11.2073 8.49024 11.1225 8.70537L8.25 6.14064C8.49095 6.06496 8.74458 6.02646 9 6.0268ZM9 3.01341C12.75 3.01341 15.9525 5.096 17.25 8.03573C16.6379 9.42404 15.5977 10.6291 14.25 11.5112L13.185 10.5536C14.2222 9.913 15.0587 9.04626 15.615 8.03573C15.0087 6.93078 14.0673 5.99986 12.898 5.34879C11.7286 4.69772 10.3781 4.35262 9 4.3527C8.1825 4.3527 7.38 4.47323 6.63 4.68752L5.475 3.66296C6.555 3.24779 7.7475 3.01341 9 3.01341ZM2.385 8.03573C2.99133 9.14068 3.93268 10.0716 5.10205 10.7227C6.27142 11.3737 7.6219 11.7188 9 11.7188C9.5175 11.7188 10.0275 11.6719 10.5 11.5781L8.79 10.0447C8.26812 9.99472 7.78112 9.78676 7.40998 9.45539C7.03884 9.12402 6.80594 8.68919 6.75 8.22323L4.2 5.93975C3.4575 6.50895 2.835 7.21877 2.385 8.03573Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPasswordNonVisible);
export default __webpack_public_path__ + "static/media/loginPasswordNonVisible.d40ca45e8dd777e90654b0e6b1ca8d3d.svg";
export { ForwardRef as ReactComponent };